import React from "react";
import type { Channel, Message, StreamChat } from "stream-chat";

export type LocalAttachmentType = Record<string, unknown>;
export type LocalChannelType = Record<string, unknown>;
export type LocalCommandType = string;
export type LocalEventType = Record<string, unknown>;
export type LocalMessageType = Record<string, unknown>;
export type LocalReactionType = Record<string, unknown>;
export type LocalUserType = Record<string, unknown>;

export type LocalMemberType = Record<string, unknown>;
export type LocalPollOptionType = Record<string, unknown>;
export type LocalPollType = Record<string, unknown>;

export type StreamChatGenerics = {
  attachmentType: LocalAttachmentType;
  channelType: LocalChannelType;
  commandType: LocalCommandType;
  eventType: LocalEventType;
  messageType: LocalMessageType;
  reactionType: LocalReactionType;
  userType: LocalUserType;
  memberType: LocalMemberType;
  pollOptionType: LocalPollOptionType;
  pollType: LocalPollType;
};

// Placeholders for the web; these will be replaced by the actual components on mobile.

export interface ChatComponentProps {
  client: StreamChat;
  children?: React.ReactNode;
}

export const PlaceholderChat: React.FC<ChatComponentProps> = ({ children }) => (
  <>{children}</>
);

// Define types for placeholders
export interface PlaceholderChannelAvatarProps {
  channel: Channel;
}

interface PlaceholderUseChatContextProps {
  client: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

// Create placeholders for web
export const PlaceholderChannelAvatar: React.FC<
  PlaceholderChannelAvatarProps
> = () => null;
export const PlaceholderUseChatContext =
  (): PlaceholderUseChatContextProps => ({ client: null });

export interface PlaceholderChannelProps {
  children: React.ReactNode;
  channel?: Channel;
  thread?: Message | null;
  additionalKeyboardAvoidingViewProps?: object;
}

export interface PlaceholderThreadProps {}

export type ChannelListProps = {
  filters: { members: { $in: string[] } };
  Preview: React.ComponentType<any>; // eslint-disable-line @typescript-eslint/no-explicit-any
};
